export default __webpack_public_path__ + "cba6094db145a732754d98286837d100.svg";